import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const HeaderWIthTextInline = ({
    header,
    text,
}) => (
    <>
        <Typography display="inline" variant="body2">
            {header}
        </Typography>
        <Typography color="textSecondary" display="inline" variant="body2">
            {text}
        </Typography>
    </>
);

HeaderWIthTextInline.propTypes = {
    header: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default HeaderWIthTextInline;
